<template>
<div 
    v-if="visible"
>

    <div
        style="margin: 10px; border: 1px solid rgba(0,0,0,0.1); border-radius: 7px;"
    >
        <div
            v-for="(item, index) in value"
            :key="index"

            style="border-bottom: 1px solid rgba(0,0,0,0.1);"
            class="card"
            v-on:click="onClickCard(item)"
        >
            <div style="float: left; padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom: 10px; max-width: 265px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" 
                class="label" 
                v-if="show(item)"
                
            >
                <span
                    v-if="!isSelected(item)"
                >
                    {{item.label}}
                </span>
                <b v-else>
                    {{item.label}}
                </b>
            </div>
            <div 
                style="float: right"
            >
                <div   
                    v-if="item.needs_attention_count > 0"
                    class="count_unread"
                >
                    {{item.needs_attention_count}}
                </div>
            </div>

            <div style="clear: both;">
            </div>

            
        </div>

    </div>
    
</div>
</template>

<script>
export default {

props: {
    value: {
        type: Array,
        default: function() { return []; }
    },
},

methods: {
    isSelected(item) 
    {
        if ( item == null ) return false;
        if ( item.endpoint == null ) return false;
        
        let active_endpoint = this.$route.params.endpoint;
        if ( active_endpoint == null ) active_endpoint = 'not-this';

        return item.endpoint.includes(active_endpoint);
    },

    show(item)
    {
        if ( item == null ) return false;
        if ( item.type == null ) return false;
        if ( item.type == 'contact-request' && item.needs_attention_count == 0 ) return false;
        if ( item.type == 'payment' && item.needs_attention_count == 0 ) return false;

        return true;
    },

    onClickCard(item)
    {
        if ( item == null ) return;

        if ( item.type == 'contact-request' )
        {
            this.$router.push({
                'name': 'search-open-contact-requests',
                'params' : {
                    'employee_id' : this.$rc.$state.employee_id,
                }
            }).catch(e=>{}); // swallow any exception
            return;
        }

        if ( item.type == 'payment' )
        {
            this.$router.push({
                'name': 'search-payments',
                'params' : {
                    'organization_id' : this.$rc.getOrganizationId()
                }
            }).catch(e=>{}); // swallow any exception
            return;
        }

        if ( item.type == 'conversation' )
        {
            this.$rc.toHomeForEndpoint(this.$router, item.endpoint, false);
            return;
        } 
    }
},

computed: {

    visible() {
        let value = this.value;

        if ( value == null ) return false;

        let active_endpoint = this.$route.params.endpoint;
        if ( active_endpoint == null ) active_endpoint = 'not-this';

        for ( let i = 0; i < value.length; i++ )
        {
            let cur = value[i];

            if ( cur.type == 'contact-request' )
            {
                if ( cur.needs_attention_count > 0 )
                    return true; // because there is a contact request that needs attention
                
                continue;
            }

            if ( cur.type == 'payment' )
            {
                if ( cur.needs_attention_count > 0 )
                    return true; // because there is a contact request that needs attention
                
                continue;
            }

            if ( cur.type == 'conversation' )
            {
                if ( cur.endpoint.includes(active_endpoint) ) 
                    continue; // this is the endpoint we are viewing...
                
                return true;
            }
        }

        return false;
    }
},

}
</script>

<style lang="scss" scoped>
.count_unread
{
    border-radius: 10px;
    background-color: #f24653;
    font-size: 12px;
    color: #FFFFFF;
    display: inline-block;
    font-size: 12px;
    height: 20px;
    letter-spacing: 0;
    line-height: 1;
    min-width: 20px;
    padding: 4px 6px;
    white-space: nowrap;
    text-align: center;
    margin-right: 5px;
    margin-top: 15px;
    margin-right: 15px;
}

.label
{

}

.card:hover .label
{
    text-decoration: underline;
}

.card:hover
{
    cursor: pointer;
}
</style>